// extracted by mini-css-extract-plugin
export default {"main_nodata":"NoProduct_main_nodata__9kbAt","btn_container4":"NoProduct_btn_container4__OwIpx"};